import { render } from "./ProfileBaselines.vue?vue&type=template&id=bf9a5892&scoped=true"
import script from "./ProfileBaselines.vue?vue&type=script&lang=js"
export * from "./ProfileBaselines.vue?vue&type=script&lang=js"

import "./ProfileBaselines.vue?vue&type=style&index=0&id=bf9a5892&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf9a5892"]])

export default __exports__